import axios from 'axios';

// ?? not ||: the Cloud Run build passes an intentionally EMPTY base URL so
// requests stay same-origin ('/api/...'); '' must not fall back to localhost.
const BASE_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:3000';

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  withCredentials: true, // This is crucial for sending/receiving session cookies
});

export default api;
